import Swiper from 'swiper';
import {Navigation, Pagination} from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

function kundenstimmen() {
	let kundenstimmenSwiper = new Swiper(".kundenstimmenSwiper", {
		loop: false,
		scrollbar: {
			el: ".swiper-scrollbar",
			draggable: true,
		},
		slidesPerView: 1.5,
		spaceBetween: 25,
		modules: [Navigation, Pagination],
		pagination: {
			el: ".swiper-pagination",
			type: "progressbar",
		},
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
	});
}

export {kundenstimmen};